import { Vector2 } from 'three';

/**
 * Where the traveller is looking, and whether they are reaching for something.
 *
 * The raw pointer is in NDC; `smooth` lags behind it so the head turns rather
 * than snaps. When no pointer has moved for a while (a phone, a kiosk) the
 * look drifts gently back to centre so the stair stays legible.
 */
export class Pointer {
  constructor(element) {
    this.el = element;
    this.raw = new Vector2(0, 0);
    this.smooth = new Vector2(0, 0);
    this.down = false;
    this.idle = 0;
    this.hasMoved = false;
    this._bound = [];

    const set = (e) => {
      const rect = this.el.getBoundingClientRect();
      this.raw.set(
        ((e.clientX - rect.left) / Math.max(rect.width, 1)) * 2 - 1,
        -(((e.clientY - rect.top) / Math.max(rect.height, 1)) * 2 - 1),
      );
      this.idle = 0;
      this.hasMoved = true;
    };

    this._on(this.el, 'pointermove', set);
    this._on(this.el, 'pointerdown', (e) => {
      set(e);
      this.down = true;
    });
    this._on(globalThis, 'pointerup', () => (this.down = false));
    this._on(globalThis, 'pointercancel', () => (this.down = false));
    this._on(globalThis, 'blur', () => (this.down = false));
  }

  _on(target, type, fn) {
    target.addEventListener(type, fn);
    this._bound.push(() => target.removeEventListener(type, fn));
  }

  update(dt) {
    this.idle += dt;
    if (this.idle > 2.6) {
      // Let the look settle back to the axis of the stair.
      this.raw.multiplyScalar(Math.pow(0.4, dt));
    }
    const lambda = 1 - Math.exp(-5.5 * dt);
    this.smooth.lerp(this.raw, lambda);
  }

  dispose() {
    this._bound.forEach((off) => off());
    this._bound.length = 0;
  }
}
